import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sl_file_hover",
  "use": "icon-sl_file_hover-usage",
  "viewBox": "0 0 31 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 31 31\" id=\"icon-sl_file_hover\"><defs><linearGradient x1=\"0.8971637487411499\" y1=\"1\" x2=\"0\" y2=\"-0.122581847012043\" id=\"icon-sl_file_hover_master_svg0_138_009566\"><stop offset=\"0%\" stop-color=\"#FFFFFF\" stop-opacity=\"1\" /><stop offset=\"100%\" stop-color=\"#FFFFFF\" stop-opacity=\"0.7400000095367432\" /></linearGradient></defs><g><g></g><g><path d=\"M4,8L4,23C4,24.6569,5.34315,26,7,26L24,26C25.6569,26,27,24.6569,27,23L27,11C27,9.895430000000001,26.1046,9,25,9L18,9C16.895400000000002,9,16,8.104569999999999,16,7C16,5.89543,15.1046,5,14,5L7,5C5.34315,5,4,6.34315,4,8Z\" fill=\"url(#icon-sl_file_hover_master_svg0_138_009566)\" fill-opacity=\"1\" /></g><g><rect x=\"14\" y=\"6\" width=\"11\" height=\"5\" rx=\"2.5\" fill=\"#FFFFFF\" fill-opacity=\"0.4699999988079071\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sl_file_hover.svg
// module id = apM0
// module chunks = 102